import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('file_upload')
export class FileUploadEntity{

    @PrimaryGeneratedColumn({
        name: "id",
      })
      id: number;
    
      @Column({
        name: "vehicle_issue_id",
      })
      vehicleIssueId: number;

      @Column('varchar',{
        name: "file_name",
        nullable:true
      })
      fileName: string;

      @Column('varchar',{
        name: "file_path",
        nullable:true
      })
      filePath: string;

      @Column('varchar',{
        name: "original_file_name",
        nullable:true
      })
      originalfileName: string;
      @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active",
      })
      isActive: boolean;
    
      @CreateDateColumn({
        name: "created_at",
        type: "datetime",
      })
      createdAt: Date;
    
      @Column("varchar", {
        nullable: true,
        name: "created_user",
      })
      createdUser: string | null;
    
      @UpdateDateColumn({
        name: "updated_at",
        type: "datetime",
      })
      updatedAt: Date;
    
      @Column("varchar", {
        nullable: true,
        name: "updated_user",
      })
      updatedUser: string | null;
    
      @VersionColumn({
        default: 1,
        name: "version_flag",
      })
      versionFlag: number;
    
}